import { render, staticRenderFns } from "./VersionAuth.vue?vue&type=template&id=5b6d48d0&scoped=true&"
import script from "./VersionAuth.vue?vue&type=script&lang=js&"
export * from "./VersionAuth.vue?vue&type=script&lang=js&"
import style0 from "./VersionAuth.vue?vue&type=style&index=0&id=5b6d48d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6d48d0",
  null
  
)

export default component.exports